<template>
  <div>
    <BaseListV2
      ref="knockautList"
      :model-class="KnockautProject"
      :collection-filter="projectFilter"
      :custom-actions="customActions()"
      :has-detail-view="false"
      :can-copy-data="false"
      :can-delete="false"
      :can-add="false"
    >
      <template #filters>
        <ContainerWithLabel label="Mandant">
          <OrganisationSelector @selected="mandatorSelected">
            <template #modal-visibility-btn-content>
              {{ selectedMandator.name }}</template
            >
          </OrganisationSelector>
        </ContainerWithLabel>
      </template>
    </BaseListV2>
    <KnockautDetailModal
      v-model:is-active="detailModalActive"
      :knockaut-project="selectedProject"
      @cancel="
        () => {
          detailModalActive = false
          selectedProject = null
        }
      "
    />
    <!-- TODO: Add <KnockautMap /> -->
  </div>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue'
import { useSnackbar } from 'vuetify-use-dialog'
import { useStore } from 'vuex'

import { CollectionFilter } from '@/api/ApiClient'
import { apiClientV2 } from '@/api/ApiClientV2'
import errorHandler from '@/api/ErrorHandler'
import KnockautDetailModal from '@/apps/brelag/brelag-supporter/components/KnockautDetailModal.vue'
// import KnockautMap from '@/apps/brelag/brelag-supporter/components/KnockautMap.vue'
import { KnockautProject } from '@/apps/brelag/common/models/knockaut'
import BaseListV2 from '@/components/common/BaseListV2.vue'
import ContainerWithLabel from '@/components/common/ContainerWithLabel.vue'
import { CustomAction } from '@/components/common/interfaces'
import OrganisationSelector from '@/components/navigation/sidebar/OrganisationSelector.vue'
import { Organisation } from '@/models/core/organisation'

const createSnackbar = useSnackbar()
const store = useStore()
const mandators = ref<Organisation[]>([])
const projectFilter = ref<CollectionFilter>({})
const selectedMandator = ref<Organisation>(
  store.state.global.context.selection.organisation
)
const selectedProject = ref<KnockautProject>(null)
const detailModalActive = ref(false)

onMounted(async () => {
  filterProjects()
  try {
    const context = {
      filter: {
        organisation: selectedMandator.value?.id,
      },
      pagination: {
        page: 1,
        pageSize: 100,
      },
    }
    const newMandators = await apiClientV2.getListItems<Organisation>(
      Organisation,
      context
    )
    mandators.value = [
      { id: null, name: '- Kein Filter -' } as Organisation,
      ...newMandators,
    ]
  } catch (error) {
    createSnackbar({
      text: errorHandler.errorToString(error),
      snackbarProps: { color: 'red-darken-3', timeout: 5000 },
    })
  }
})

function mandatorSelected(newOrg: Organisation): void {
  selectedMandator.value = newOrg
  filterProjects()
}

function filterProjects() {
  projectFilter.value = {
    organisation: selectedMandator.value?.id,
  }
}

function customActions(): CustomAction[] {
  const actions: CustomAction[] = [
    {
      label: 'Details',
      type: 'is-info',
      icon: 'mdi-arrow-expand',
      callback: async (project: KnockautProject) => {
        selectedProject.value = project
        detailModalActive.value = true
      },
    },
  ]
  return actions
}
</script>

<style></style>
